import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import constant from '../../../constant';

const EventForm = ({ data, onSubmit }) => {
    const [state, setState] = useState({
        planType: { name: 'planType', value: data?.PLAN_TYPE || '', isRequired: true, error: '' },
        remark: { name: 'remark', value: data?.DESCRIPTION || '', isRequired: false, error: '' },
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    const handleReset = () => {
        const resetState = { ...state };
        Object.keys(resetState).forEach(key => {
            resetState[key].value = data?.[key.toUpperCase()] || (key === 'isActive' ? true : '');
            resetState[key].error = '';
        });
        setState(resetState);
    };



    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label>Plan Type {state.planType.isRequired && <span className='text-danger'> *</span>}</label>
                    <input
                        type="text"
                        name={state.planType.name}
                        value={state.planType.value}
                        onChange={handleChange}
                        placeholder="Enter plan type"
                        className={`form-control ${state.planType.error ? 'is-invalid' : ''}`}
                    />
                    {state.planType.error && <div className="invalid-feedback">{state.planType.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Description</label>
                    <input
                        type="text"
                        name={state.remark.name}
                        value={state.remark.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="2"
                        placeholder="Any additional notes"
                    />
                </div>


            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a href={constant.Authedcomponent.projectDocumentCount.url} className="btn btn-danger" onClick={handleReset}>Cancel</a>
            </div>
        </form>
    );
};

export default EventForm;
